import { developmentConfig } from 'configurations/development';
export const environment = developmentConfig;
